// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"59701fda","455":"0e2d7f1b","488":"79b647ad","644":"ae0fb291"}[chunkId] + ".chunk.js";
};